/**
 * @fileoverview API para operações de produtos, categorias e marcas.
 * @module productsApi
 * @requires ./api
 * @since 1.0.0
 */

import api from './api';

/**
 * Busca todos os produtos.
 * @async
 * @function getProducts
 * @returns {Promise<Array>} Lista de produtos
 */
export const getProducts = async () => {
  const response = await api.get('/products');
  return response.data.data;
};

/**
 * Busca todas as categorias.
 * @async
 * @function getCategories
 * @returns {Promise<Array>} Lista de categorias
 */
export const getCategories = async () => {
  const response = await api.get('/products/categories');
  return response.data.data;
};

/**
 * Busca todas as marcas.
 * @async
 * @function getBrands
 * @returns {Promise<Array>} Lista de marcas
 */
export const getBrands = async () => {
  const response = await api.get('/products/brands');
  return response.data.data;
};
